import React from 'react';
import { Button, Flex, Grid, GridItem, Spacer } from '@chakra-ui/react';
import { GetInstances, SetInstance } from '../api/authentication-controller';
import { Context } from '../App';
import { RoutePath, SPACING } from '../generic/config';
import { useMutation, useQuery } from 'react-query';
import { QueryKeys } from '../api/base/react-query';
import { QUERY_CLIENT } from '..';
import { useNavigate } from 'react-router-dom';
import Card from '../base-components/Card';
import { useScopes } from '@/model/Token';

const SelectInstancePage: React.FC = () => {
    const navigate = useNavigate();
    const { translations } = React.useContext(Context);
    const instances = useQuery(QueryKeys.instances, GetInstances);
    const { mutateAsync: doSetInstance } = useMutation(SetInstance);
    const scope = useScopes();
    const isAdmin = scope.includes("ADMIN") || scope.includes("SUPERUSER");
    const targetPage = isAdmin ? RoutePath.Dashboard : RoutePath.Tasks;

    React.useEffect(() => {
        if (instances.data?.length === 1) {
            doSetInstance(instances.data[0].instanceId).then(() => {
                QUERY_CLIENT.invalidateQueries();
                navigate(targetPage);
            });
        }
    }, [instances.data, doSetInstance, navigate, targetPage]);

    return (
        <Grid templateColumns="repeat(5, 1fr)" gap={SPACING}>
            <Spacer />
            <GridItem colSpan={3}>
                <Card title={translations.installation.title} description={translations.installation.description}>
                    <Flex flexDir={"column"}>
                        {instances.data?.map((instance) => (
                            <Button
                                key={instance.instanceId}
                                onClick={async () => {
                                    await doSetInstance(instance.instanceId);
                                    QUERY_CLIENT.invalidateQueries();
                                    navigate(targetPage);
                                }}
                                my={SPACING / 2}
                            >{instance.name}</Button>
                        ))}
                    </Flex>
                </Card>
            </GridItem>
        </Grid>
    );
};

export default SelectInstancePage;